import React from 'react'
import styled from 'styled-components'

const StyledLayoutMain = styled.main``

const LayoutMain = ({ children }) => (
  <StyledLayoutMain>{children}</StyledLayoutMain>
)

export default LayoutMain



// WEBPACK FOOTER //
// ./src/components/LayoutMain.js